import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'store';

// material-ui
import { useTheme } from '@mui/material/styles';
import { useMediaQuery, Box, Container } from '@mui/material';

// project import
import Drawer from './Drawer';
import Header from './Header';
// import Footer from './Footer';
import Breadcrumbs from 'components/@extended/Breadcrumbs';
import ScrollTop from 'components/ScrollTop';

import navigation from 'menu-items';
import { openDrawer } from 'slices/menu';
import Content from './Content';
import { DRAWER_WIDTH } from 'config';
import { useGetRoleQuery } from 'services/auth';
import LocationChangeReset from 'components/LocationChangeReset';

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
  const theme = useTheme();
  const matchDownLG = useMediaQuery(theme.breakpoints.down('lg'));
  const dispatch = useDispatch();

  const _ = useGetRoleQuery(undefined, { refetchOnFocus: true });

  const { container } = useSelector((state) => state.config);
  const { drawerOpen } = useSelector((state) => state.menu);

  // drawer toggler
  const [open, setOpen] = useState(drawerOpen);
  const handleDrawerToggle = () => {
    setOpen(!open);
    dispatch(openDrawer({ drawerOpen: !open }));
  };

  // set media wise responsive drawer
  useEffect(() => {
    setOpen(!matchDownLG);
    dispatch(openDrawer({ drawerOpen: !matchDownLG }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchDownLG]);

  useEffect(() => {
    if (open !== drawerOpen) setOpen(drawerOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drawerOpen]);

  return (
    <ScrollTop>
      <LocationChangeReset />
      <Box sx={{ display: 'flex', width: '100%' }}>
        <Header open={open} handleDrawerToggle={handleDrawerToggle} />
        <Drawer open={open} handleDrawerToggle={handleDrawerToggle} />
        <Box
          component="main"
          sx={{
            width: `calc(100% - ${DRAWER_WIDTH}px)`,
            maxHeight: { xs: 'calc(100vh - 76px)', lg: 'calc(100vh - 124px)' },
            overflowY: 'auto',
            mt: { xs: '76px', lg: '124px' },
            flexGrow: 1,
            p: { xs: 2, lg: 4 },
            pt: { lg: '0 !important' },
            borderTop: { xs: '1px solid #DDDDDD', lg: 'none' }
          }}
        >
          <Container
            maxWidth={container ? 'xl' : false}
            sx={{
              px: '0 !important',
              position: 'relative',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Breadcrumbs navigation={navigation} title titleBottom card={false} divider={false} />
            <Content />
            {/* <Footer /> */}
          </Container>
        </Box>
      </Box>
    </ScrollTop>
  );
};

export default MainLayout;
